// extracted by mini-css-extract-plugin
module.exports = {"infoSupp":"Info_infoSupp__OzAIk","icon":"Info_icon__UvlhB","error":"Info_error__evCBi","checkmark":"Info_checkmark__Xv5Rh"};